import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Documento } from '../models/data.model';

@Pipe({
  name: 'internationalActivitiesUserManualsFilter'
})
@Injectable()
export class InternationalActivitiesUserManualsFilterClass implements PipeTransform {
  transform(value: any, args?: any): any {
    if (!value) return null;
    if (!args) return value;

    args = args.toLowerCase();

    return value.filter(function (data) {
      return JSON.stringify(data).toLowerCase().includes(args);
    });
  }
}
